import { MarketingGoalTargets, outcomeGoalMetrics, UserId } from "@sp-crm/core";

export interface GoalVersionLike extends MarketingGoalTargets {
    marketerUserId: UserId;
    effectiveMonth: string;
}

export const resolveActiveGoalVersion = <T extends { effectiveMonth: string }>(
    versions: T[],
    month: string,
): T | null => {
    let active: T | null = null;
    for (const version of [...versions].sort((a, b) =>
        a.effectiveMonth.localeCompare(b.effectiveMonth),
    )) {
        if (version.effectiveMonth <= month) {
            active = version;
        }
    }
    return active;
};

export const versionTargets = (version: MarketingGoalTargets): MarketingGoalTargets => ({
    activity: { ...version.activity },
    referrals: version.referrals,
    careStarts: version.careStarts,
    movesCompleted: version.movesCompleted,
});

export const targetsKey = (targets: MarketingGoalTargets): string => {
    const entries: [string, number][] = [
        ...outcomeGoalMetrics.map((metric): [string, number] => [
            metric,
            targets[metric],
        ]),
        ...Object.entries(targets.activity),
    ];
    return JSON.stringify(
        entries.filter(([, value]) => value > 0).sort(([a], [b]) => a.localeCompare(b)),
    );
};
